import React from 'react';
import { Switch } from 'antd';
import classNames from 'classnames';
import styles from './Header.scss';

const ThemeSwitcher = ({ theme, toggleTheme }) => {
  const isDarkTheme = theme === 'vs-dark';

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span
        className={classNames({
          [styles['gray-text']]: isDarkTheme,
          [styles['black-text']]: !isDarkTheme,
        })}
        style={{ fontSize: '14px', marginRight: '4px' }}
      >
        Light
      </span>
      <Switch
        checked={isDarkTheme}
        onChange={toggleTheme}
      />
      <span
        className={classNames({
          [styles['white-text']]: isDarkTheme,
          [styles['gray-text']]: !isDarkTheme,
        })}
        style={{ fontSize: '14px', marginLeft: '4px' }}
      >
        Dark
      </span>
    </div>
  );
};

export default ThemeSwitcher;
